export default __webpack_public_path__ + "static/media/GermSafe_logo_color_72dpi.edf34a50.png";